import React, { useState } from "react";

function Services() {
  const [activeIndex, setActiveIndex] = useState(null);

  const services = [
             {
              title: "Enterprise ERP",
              image: process.env.PUBLIC_URL + "/erp-enterprise.png",
      short:
        "MetaVix helps you design, implement, and optimize Oracle Cloud applications so finance, supply chain, HR, and planning all run on a single, modern cloud platform with one trusted data model. By unifying Oracle Cloud ERP, EPM, HCM, and SCM, we connect and automate end-to-end processes and give leaders real‑time visibility to make faster, smarter decisions.",
      sections: [
        {
          heading: "Oracle Cloud ERP",
          content:
            "We implement and optimize Oracle Cloud ERP to modernize your core financials, procurement, projects, and supply chain operations. Our team helps you define the right ERP scope, configure standard best‑practice processes, integrate with surrounding systems, and minimize customizations so you get a stable, upgrade‑friendly environment with lower total cost of ownership.",
        },
        {
          heading: "Oracle Cloud EPM",
          content:
            "MetaVix leverages Oracle Cloud EPM to bring together planning, budgeting, forecasting, and financial close on top of your ERP data. We integrate EPM with ERP and HCM so finance and HR can plan using real‑time actuals, run scenario modeling, speed up month‑end close, and move from spreadsheet chaos to connected enterprise performance management.",
        },
        {
          heading: "Oracle Cloud HCM",
          content:
            "With Oracle Cloud HCM, we help you streamline HR, payroll, talent, and workforce management on a single platform that’s tightly connected to finance. This integration gives you one employee record across HR and ERP, improving workforce planning, compliance, and employee experience while reducing manual reconciliation and duplicate data.",
        },
        {
          heading: "Oracle Cloud SCM",
          content:
            "For supply chain, MetaVix configures Oracle Cloud SCM to connect planning, sourcing, manufacturing, inventory, and logistics in real time. We enable prebuilt analytics on top of SCM data, so supply chain teams can monitor exceptions, improve service levels, reduce costs, and respond quickly to demand or supply disruptions.",
        },
        {
          heading: "How We Deliver ERP Implementation",
          content:
            "MetaVix follows an Oracle‑aligned, phased implementation methodology so ERP projects are predictable, on time, and on budget. Typical phases include:",
bullets: [
        "Discover & design: Assess current processes, define scope and success metrics, choose the right Oracle Cloud modules, and design future‑state workflows aligned with best practices.",
        "Configure & integrate: Configure Oracle Cloud ERP, set up security and controls, design integrations with legacy, CRM, and other systems, and define data migration strategy.",
        "Test, train & deploy: Run system and user testing, migrate data, train end users and support teams, and execute a controlled go‑live with clear cutover and rollback plans.",
        "Optimize & support: After go‑live, we stabilize the system, fine‑tune configurations and reports, and roll out additional features or modules in phases.",
      ],
        },
      ],
    },
    {
      title: "AI & Digital Innovations",
      image:
        "https://images.unsplash.com/photo-1677442136019-21780ecad995?q=80&w=1200",
      short:
        "MetaVix helps automate and connect business processes using modern AI and digital solutions, transforming disconnected systems into a unified, intelligent enterprise. We design AI‑driven experiences that reduce manual work, improve decision‑making, and allow your teams to focus on high‑value activities instead of repetitive tasks.",
      sections: [
        {
          heading: "What We Do With AI",
          content:
            "We work with your leadership and IT teams to identify high‑impact AI use cases—such as document automation, forecasting, customer service assistants, and intelligent recommendations and then design a roadmap from pilot to full‑scale deployment. Our experts integrate generative AI, machine learning, and analytics into your existing systems so that insights and automations appear directly inside the tools your people already use.",
        },
        {
          heading: "AI Inside ERP: Copilots and Agents",
          content:
            "MetaVix builds AI copilots and ERP agents that live inside your ERP to guide users, answer questions, and execute workflows. These AI helpers can summarize financials on demand, forecast cash flow, highlight process bottlenecks, and recommend next best actions for finance, supply chain, and operations teams and Going beyond simple copilots, we design ERP AI agents that can watch for specific conditions (like low inventory or overdue invoices), analyze data, and automatically trigger workflows such as generating purchase orders, routing approvals, or updating delivery schedules—always within defined business rules and approval controls.",
        },
        {
          heading: "Connecting ERP, CRM, and Other Systems",
          content:
            "To truly 'connect business processes, we use AI‑powered automation and integrations to link ERP with CRM, e‑commerce, and other line of business systems. This allows events in one system to automatically trigger end‑to‑end workflows in ERP order processing, inventory checks, invoicing, and reporting without manual re‑entry or delays.",
        },
	{
          heading: "Governance, Security, and Adoption",
          content:
            "MetaVix also helps you implement AI responsibly by putting in place guardrails, access controls, and audit trails so ERP agents and copilots operate safely and transparently. We support user training and change management so that your teams trust the AI, understand how to use it, and actually adopt these new digital co‑workers in their day‑to‑day work.",
        },
      ],
    },

    {
      title: "Data Analytics & Insights",
      image:
        "https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=1200",
      short:
        "At MetaVix Solutions, our Data Analytics and Business Intelligence services help you transform into a truly data‑driven enterprise by turning scattered data into clear, actionable insights for leadership and frontline teams. We connect data from across your business, apply advanced analytics, and deliver intuitive dashboards so executives can make fast, confident decisions based on accurate, current, and comprehensive information",
      sections: [
        {
          heading: "How We Work With Your Data",
          content:
            "We begin with a thorough assessment of your existing data sources, reporting processes, and analytics maturity to understand where data is stored, how it is used today, and what decisions it needs to support. Our team then designs a tailored BI and analytics architecture—covering data integration, data warehousing or data lakes, and ETL/ELT pipelines—to ensure that the right data is clean, consistent, and available in one trusted place.",
        },
        {
          heading: "From Reports to Actionable Intelligence",
          content:
            "Instead of just creating static reports, MetaVix Solutions builds interactive dashboards and KPI views for executives and business users that highlight what is happening, why it is happening, and what to do next. We use advanced analytics techniques such as drill‑down exploration, trend analysis, and predictive modeling to move beyond historical reporting and help you forecast sales, identify risks, and spot new growth opportunities before competitors do.",
        },
        {
          heading: "Empowering Executive Decision‑Making",
          content:
            "Our solutions are designed specifically for executive management, giving leaders a real‑time, single view of performance across finance, operations, sales, and customer experience. By replacing manual spreadsheets and delayed reports with automated, validated dashboards, we enable faster, data‑driven decisions that improve productivity, reduce costs, and increase profitability.",
        },
	{
          heading: "Why MetaVix Solutions Does It Best",
          content:
            "MetaVix Solutions acts as a long‑term analytics partner, not just a tool implementer: we align every dashboard, KPI, and model with clear business outcomes such as revenue growth, margin improvement, or customer retention. We also focus on user adoption through training, documentation, and change management, so your teams actually use the insights in daily decisions—turning your analytics investment into a sustainable competitive advantage.",
        },
      ],
    },

    {
      title: "IT Strategy Consulting",
      image:
        "https://images.unsplash.com/photo-1552664730-d307ca884978?q=80&w=1200",
      short:
        "At MetaVix Solutions, our IT Strategy Consulting services help organizations turn technology into a true business enabler, not just a cost center—by aligning every IT initiative with clear, measurable business goals. We partner with executive and IT leaders to assess your current technology landscape, identify gaps, and design a pragmatic, future-ready roadmap that supports innovation, operational efficiency, and long‑term growth.",
      sections: [
        {
          heading: "What We Do",
          content:
            "We start by evaluating your existing IT infrastructure, applications, and processes to understand what is working, what is holding you back, and where the biggest opportunities lie. Based on this assessment, we develop a strategic technology roadmap that prioritizes initiatives such as cloud adoption, cybersecurity improvements, data and analytics capabilities, and process automation in line with your business objectives. Our team then helps you sequence these initiatives into an actionable plan, ensuring that investments are realistic, achievable, and aligned with budget and resource constraints.",
        },
        {
          heading: "How We Work With Leadership",
          content:
            "MetaVix Solutions works closely with your leadership team—across business and IT—to co-create a shared vision for how technology will support your strategy. We facilitate structured workshops and roadmap sessions to translate high-level goals (like revenue growth, customer experience, or cost optimization) into concrete IT programs and projects. This collaborative approach builds buy‑in across stakeholders and creates a clear, visual roadmap that guides decision‑making over the next 12–24 months.",
        },
        {
          heading: "Value You Can Expect",
          content:
            "By engaging MetaVix Solutions for IT Strategy Consulting, organizations gain a clearer picture of where to focus technology investments and how to avoid fragmented, ad hoc IT decisions. Our strategic guidance helps you improve operational efficiency, reduce risk, and unlock new opportunities for digital innovation—so your technology roadmap not only supports today’s needs, but also scales with your future growth.",
        },
      ],
    },

{
  title: "Staff Augmentation Services",
  image: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?q=80&w=1200",
  short:
    "MetaVix provides high caliber technology and business professionals who work as an extension of your team while you retain control over priorities, tools, and day to day management. Our resources bring years of hands on experience in enterprise environments and are selected not just for technical depth but also for communication skills, reliability, and cultural fit.",

  sections: [
    {
      heading: "Requirement and Role Definition",
      content:
        "We start with detailed working sessions with your leaders and delivery teams to understand:",
      subpoints: [
        "Business objectives and project scope",
        "Exact skills, seniority level, and domain experience needed",
        "Engagement model (full time, part time, on-site, remote), duration, and budget",
        "This mirrors best practices where successful augmentation starts with a precise skills and gap analysis rather than vague requests"
      ]
    },
    {
      heading: "Targeted Sourcing and Deep Pre-Vetting",
      content:
        "Based on the agreed role profiles, MetaVix taps into a curated network of specialists across AI, cloud, ERP, engineering, and business roles.",
      subpoints: [
        "Technical assessments and hands-on exercises",
        "Structured interviews to validate problem-solving and communication",
        "Culture and collaboration fit checks",
        "We ensure only top-tier candidates are presented."
      ]
    },
    {
      heading: "Shortlist Presentation and Client Interviews",
      content:
        "Once we have a strong slate, we:",
      subpoints: [
        "Present a shortlist of candidates mapped to your requirements.",
        "Provide experience summaries and rate information",
        "Coordinate client interviews so you have final selection control."
      ]
    },
    {
      heading: "Structured Onboarding and Integration",
      content:
        "After selection, MetaVix ensures a smooth onboarding process:",
      subpoints: [
        "Completion of NDAs, compliance, and contracts",
        "Access to tools, environments, and documentation before day one",
        "Alignment on objectives, deliverables, and KPIs",
        "Encouraging full team integration for maximum productivity."
      ]
    },
    {
      heading: "Ongoing Governance and Performance Management",
      content:
        "MetaVix provides structured governance similar to enterprise consulting firms:",
      subpoints: [
        "Dedicated engagement manager or delivery lead",
        "Regular performance and workload reviews",
        "Flexible scaling of team based on evolving needs",
        "Alignment with project metrics and outcomes"
      ]
    },
    {
      heading: "Knowledge Transfer and Offboarding",
      content:
        "At the end of engagement, we ensure structured transition:",
      subpoints: [
        "Documentation and handover of code, configurations, and processes",
        "Transition of responsibilities to internal teams",
        "Formal knowledge transfer to avoid loss of expertise"
      ]
    },
    {
      heading: "Roles and Expertise Areas",
      content:
        "MetaVix’s Staff Augmentation Services cover a wide range of roles:",
      subpoints: [
        "AI & Machine Learning Engineers",
        "AI Product Managers and Prompt Engineers",
        "Cloud Architects (AWS, Azure, GCP)",
        "Software Development and Engineering ",
        "ERP and CRM Solutions – Oracle, SAP, Salesforce, Dynamics",
        "Database Design and Administration",
        "Network Engineering and Administration",
        "Project Management",
        "Business Analyst"
      ]
    }
  ]
},
    {
      title: "Solutions & Training",
      image:
        "https://images.unsplash.com/photo-1509062522246-3755977927d7?q=80&w=1200",
      short:
        "MetaVix Solutions delivers hands on IT and Oracle Cloud training led by experienced consultants and corporate trainers, either at your location or in a live, interactive online environment. Every program emphasizes real world exercises, labs, and use cases, so your teams don’t just learn concepts—they practice them using scenarios that mirror your day‑to‑day work.",
      full:
        "We specialize in enablement for Oracle Cloud ERP, EPM, HCM, and SCM, plus Oracle Analytics, Fusion Data Intelligence (FDI)/Oracle Analytics Cloud (OAC), and Oracle AI agents and assistants. Training is role based and modular—covering implementers, power users, administrators, and business users—so finance, HR, supply chain, and analytics teams each get depth on the features, reports, and workflows that matter most to their roles. Our training programs are designed to accelerate adoption, reduce support tickets, and empower your teams to get the most value from your technology investments.",
    },
  ];

  return (
  <div>

    {/* HERO */}
    <section className="bg-gradient-to-r from-blue-900 to-blue-700 text-white py-5 text-center">
      <h1 className="text-4xl font-bold mb-4">Our Services</h1>
      <p className="text-blue-200 max-w-2xl mx-auto">
        Explore our ERP, AI, and Data-driven solutions.
      </p>
    </section>

    {/* SERVICES */}
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 space-y-16">

        {services.map((service, index) => (

          <div key={index} className="border-b pb-10">

            <div className="grid md:grid-cols-2 gap-10 items-start">

              {/* IMAGE */}
              <div>
                <img
                  src={service.image}
                  alt={service.title}
                  className="rounded-xl shadow-md w-full h-64 object-cover"
                />
              </div>

              {/* TEXT */}
              <div>

                <h2 className="text-2xl font-bold text-blue-800 mb-3">
                  {service.title}
                </h2>

                <p className="text-gray-600 mb-4">
                  {service.short}
                </p>

                <button
                  onClick={() =>
                    setActiveIndex(activeIndex === index ? null : index)
                  }
                  className="text-red-600 font-semibold mb-4"
                >
                  {activeIndex === index ? "− Show Less" : "+ Learn More"}
                </button>

                {/* ✅ EXPANDED BLOCK */}
                {activeIndex === index && (
                  <div className="bg-gray-100 p-5 rounded-lg text-gray-700 space-y-4">

                    {service.full && <p>{service.full}</p>}

                    {service.bullets && (
                      <ul className="list-disc pl-5 space-y-2">
                        {service.bullets.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>
                    )}

                    {service.sections &&
                      service.sections.map((sec, i) => (
                        <div key={i}>
                          <h3 className="font-semibold text-lg text-blue-900 border-l-4 border-red-500 pl-3 mb-2">
                            {sec.heading}
                          </h3>

                          <p className="mb-2">{sec.content}</p>

                          {sec.subpoints && (
                            <ul className="list-disc pl-5 space-y-1">
                              {sec.subpoints.map((point, j) => (
                                <li key={j}>{point}</li>
                              ))}
                            </ul>
                          )}
                        </div>
                      ))}

                  </div>
                )}

              </div>

            </div>

          </div>

        ))}

      </div>
    </section>

  </div>
);
}

export default Services;